import { UtilitarioService } from '@app/services/utilitario.service';
import { Participante } from './participante.model';
import { Unidade } from './unidade.model';

export class Pagar {
  Id: number;
  Numero: string;
  Parcela: string;
  ParticipanteId: number;
  Participante: Participante;
  FormaDePagamentoCodigo: string;
  Emissao: string;
  Vencimento: string;
  DataPagamento: Date;
  Valor: number;
  JurosAtraso: number;
  Desconto: number;
  TaxaCartao: number;
  UsuarioRecebimentoId: number;
  ValorPago: number;
  Historico: string;
  // ParticipanteNome: string;
  // TipoDRNome: string;
  DemonstrativoDeResultadoId: number;
  ProcessoId: number;
  PagamentoLiberado: boolean;
  ReceberReferenciaId: number;
  SobreAdvogado: boolean;
  SobreDespesas: boolean;
  SobreSubstabelecido: boolean;
  // PagamentoValidado:boolean;
  // DataEnviadoValidacao: string;
  // DataValidado: string;
  // RemovidaDaValidacao: boolean;
  UnidadeId: number;
  Unidade: Unidade;
  NumeroCopias: number;
  RateioId: number;
  TutelaProvisoriaId: number;

  constructor() {
    this.Id = 0;
  }
}

export class PagarListaFiltros {

  ParticipanteId: number;
  PagasRecebidas: boolean;
  NaoPagasRecebidas: boolean;
  ProcessoId: number;
  SomenteLiberadas: boolean;
  DataInicial: string;
  //DataInicial: Date;

  DataFinal: string;
  //DataFinal: Date;

  Pagina: number;
  UnidadeId: number;
  DemonstrativoDeResultadoId: number;
  Observacao: string;
  TipoData: string;

  constructor() {
    this.PagasRecebidas = false;
    this.NaoPagasRecebidas = true;
    this.SomenteLiberadas = true;
    this.ParticipanteId = 0;
    this.ProcessoId = 0;
    this.UnidadeId = 0;
    this.DemonstrativoDeResultadoId = 0;
    this.TipoData = 'Vencimento';

    // const hoje = new Date();
    // this.DataInicial = hoje.toISOString().split('T')[0];
    // this.DataInicial = UtilitarioService.retornaDataAtualMaisDias(0);
    // hoje.setDate(hoje.getDate() + 7);
    // this.DataFinal = hoje.toISOString().split('T')[0];
    // this.DataFinal = UtilitarioService.retornaDataAtualMaisDias(7);
    this.DataFinal = UtilitarioService.retornaDataAtualMaisDiasISO(7);
    this.DataInicial = UtilitarioService.retornaDataAtualMaisDiasISO(0);

  }
}

export class PagarLista {
  Id: number;
  Numero: string;
  Parcela: string;
  Participante: string;
  FormaDePagamentoCodigo: string;
  Vencimento: string;
  DataPagamento: string;
  Valor: number;
  Desconto: number;
  ValorPago: number;
  Historico: string;
  Selecionado: boolean;
  JurosAtraso: number;
  ProcessoId: number;
  PagamentoLiberado: boolean;
  PagamentoValidado: boolean;
  DataEnviadoValidacao: string;
  DataValidado: string;
  RemovidaDaValidacao: boolean;
  UnidadeId: number;
  ExibirHistorico: boolean;
  DemonstrativoDeResultado: string;
  Quitado: boolean;
  Rateio: boolean;
  checked: boolean;

  constructor() {
    this.DataPagamento = (new Date()).toISOString();
    this.UnidadeId = 0;
  }
}
